
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { AppInputImage } from '@/components'
import { appEntity } from '@/models/models'
import '@/extensions/string'
import {
    ImageInterface,
    placeholderLogo,
    placeholderBanner,
    placeholderSplashscreen,
    createImage,
} from '@/utils/image'

@Component({
    components: {
        AppInputImage,
    },
})
export default class DetailBasicImageForm extends Vue {
    @Prop() public value?: AppEntity
    private appEntity?: AppEntity
    private logo: ImageInterface = placeholderLogo
    private banner: ImageInterface = placeholderBanner
    private splashscreen: ImageInterface = placeholderSplashscreen

    get app(): AppEntity {
        this.appEntity = this.value ? this.value : appEntity
        return this.appEntity
    }

    get userLogo(): string {
        return this.logo.imageURL === placeholderLogo.imageURL
            ? ''
            : this.logo.imageURL
    }

    get userBanner(): string {
        return this.banner.imageURL === placeholderBanner.imageURL
            ? ''
            : this.banner.imageURL
    }

    get userSplashscreen(): string {
        return this.splashscreen.imageURL === placeholderSplashscreen.imageURL
            ? ''
            : this.splashscreen.imageURL
    }

    @Watch('app')
    public onAppChange() {
        this.logo = createImage(this.app.logo, placeholderLogo)
        this.banner = createImage(this.app.banner, placeholderBanner)
        this.splashscreen = createImage(this.app.splashscreen, placeholderSplashscreen)
    }

    public onLogoChanged(logo: ImageInterface) {
        this.$store.commit('detail/setImageApp', {
            key: 'logo',
            image: logo,
        })
        this.logo = logo
        this.onImageChanged()
    }

    public onBannerChanged(banner: ImageInterface) {
        this.$store.commit('detail/setImageApp', {
            key: 'banner',
            image: banner,
        })
        this.banner = banner
        this.onImageChanged()
    }

    public onSplashscreenChanged(splashscreen: ImageInterface) {
        this.$store.commit('detail/setImageApp', {
            key: 'splashscreen',
            image: splashscreen,
        })
        this.splashscreen = splashscreen
        this.onImageChanged()
    }

    @Emit('input')
    public onImageChanged() {
        this.appEntity!.logo = this.userLogo
        this.appEntity!.banner = this.userBanner
        this.appEntity!.splashscreen = this.userSplashscreen
        return this.appEntity
    }

    @Watch('app.logo', { deep: true })
    private onLogoAdded() {
        delete this.appEntity!.errors.logoImage
    }

    @Watch('app.splashscreen', { deep: true })
    private onSplashscreenAdded() {
        delete this.appEntity!.errors.splashscreen
    }

    @Watch('app.banner', { deep: true })
    private onBannerAdded() {
        delete this.appEntity!.errors.banner
    }

    @Watch('app.android.request', { deep: true })
    private onAndroidRequest(newValue: boolean, oldValue: boolean) {
        if (this.appEntity == null) {
            return
        }

        if (
            newValue &&
            (this.app.banner == null || this.app.banner.isEmpty())
        ) {
            this.appEntity.errors.banner = 'Não pode ser vazio'
        } else {
            delete this.appEntity.errors.banner
        }

        this.onImageChanged()
    }

    @Watch('app.iOS.request', { deep: true })
    private onIOSRequest(newValue: boolean, oldValue: boolean) {
        if (this.appEntity == null) {
            return
        }

        if (
            newValue &&
            (this.app.splashscreen == null || this.app.splashscreen.isEmpty())
        ) {
            this.appEntity.errors.splashscreen = 'Não pode ser vazio'
        } else {
            delete this.appEntity.errors.splashscreen
        }

        return this.onImageChanged()
    }
}
